import React from 'react';

const WeatherApp = () =>
{
    return(
        <section className="weatherApp-section">
            <div className="col">
                <h1>Weather Assistant in your phone</h1>
                <p>Find Out Rain and floods beckon as La Nina looms and IOD deepens.</p>
            </div>
            <div className="col">
                
            </div>
        </section>
    )
}

export default WeatherApp;